export default __webpack_public_path__ + "ui/img/brands/whatsapp.svg";